import React from "react";
import cn from "classnames";
import { AlertProps } from ".";
import Styles from "./forms.module.scss";

export const Alert = ({
  size = "md",
  variant = "error",
  title,
  klass = "",
  persist = false,
  children
}: AlertProps) => {
  if (!children && !persist) {
    return null;
  }
  return (
    <div className={cn(Styles.alert, children && variant, size, klass, { persist: !children, hasTitle: title?.length })}>
      {title && <h5>{title}</h5>}
      <p className={`text-${size}`}>
        {children || '\u00A0'}
      </p>
    </div>
  );
};

export default Alert;
